export function initHeader(): void {
  const btn    = document.querySelector<HTMLButtonElement>('header.header > button')
  const drawer = document.querySelector<HTMLElement>('.header-drawer')

  if (!btn || !drawer) return

  btn.addEventListener('click', () => {
    const isOpen = document.body.classList.toggle('js-menuopen')
    btn.setAttribute('aria-expanded', String(isOpen))
  })

  // ドロワー外のオーバーレイをタップで閉じる
  drawer.addEventListener('click', (e) => {
    if (e.target === drawer) closeMenu()
  })

  // ドロワー内のリンククリックでメニューを閉じる（SP）
  drawer.querySelectorAll<HTMLAnchorElement>('a').forEach(link => {
    link.addEventListener('click', () => {
      if (document.body.classList.contains('js-menuopen')) closeMenu()
    })
  })

  function closeMenu(): void {
    document.body.classList.remove('js-menuopen')
    btn!.setAttribute('aria-expanded', 'false')
  }
}
